import { axios } from 'lib/axios';

export const getSupplierSearchPreferences = async () => {
  const { data } = await axios.get('/api/users/preferences');

  return data?.supplierSearch ?? null;
};

export const saveSupplierSearchPreferences = ({ competenceAreas, starred }) =>
  axios.put('/api/users/preferences', { supplierSearch: { competenceAreas, starred } });
